import styled from "styled-components";
import media from "styled-media-query";

import { Text, ColorV2, Button } from "@adoptaunabuelo/react-components";
import { Calendar, Sparkles, Users2 } from "lucide-react";

const screenSize2: any = "1024px";

const CellContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: fit-content;
	min-width: 388px;
	border-radius: 12px;
	overflow: hidden;
	background-color: white;
	cursor: pointer;
	${media.lessThan("medium")`
        width: 100%;
        min-width: 100%;
    `}
`;
const Section = styled.div`
	padding: 24px;
	${media.lessThan(screenSize2)`
        padding: 20px;
    `}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;
const Image = styled.img`
	height: 109px;
	width: 109px;
	border-radius: 12px;
	object-fit: cover;
`;
const Chip = styled.div`
	display: flex;
	padding: 4px 8px;
	border-radius: 20px;
	width: fit-content;
	align-items: center;
	justify-content: center;
	gap: 6px;
	background-color: ${ColorV2.surface.secondary};
`;

const PackCell = (props: Props) => {
	const onCellClick = () => {
		window.open(`${window.location.origin}/pack?id=wwHBQNXoKr`, "_blank");
	};

	return (
		<CellContainer onClick={onCellClick}>
			<Row style={{ padding: "24px 24px 0px", gap: 24 }}>
				<Col style={{ flex: 1, gap: 8 }}>
					<Chip>
						<Sparkles
							height={16}
							width={16}
							color={ColorV2.text.neutralHard}
						/>
						<Text type="p2">Novedad</Text>
					</Chip>
					<Text
						type="p"
						weight="medium"
						style={{
							display: "flex",
							height: 70,
							textOverflow: "ellipsis",
							wordWrap: "break-word",
							overflow: "hidden",
						}}
					>
						{props.title}
					</Text>
				</Col>
				<Image src={props.image} />
			</Row>
			<Section>
				<Col>
					<Row>
						<Users2
							style={{
								marginRight: 12,
								minHeight: 24,
								minWidth: 24,
							}}
							height={24}
							width={24}
							color={ColorV2.text.neutralHard}
						/>
						<Text
							type="p"
							style={{
								marginTop: 1,
							}}
						>
							{props.amount} personas ya tienen su pack
						</Text>
					</Row>
					<Row style={{ marginTop: 8 }}>
						<Calendar
							style={{
								marginRight: 12,
								minHeight: 24,
								minWidth: 24,
							}}
							height={24}
							width={24}
							color={ColorV2.text.neutralHard}
						/>
						<Text
							type="p"
							style={{
								marginTop: 1,
							}}
						>
							Disponible hasta el 15 de diciembre
						</Text>
					</Row>
				</Col>
				<Button
					size="small"
					style={{
						width: "100%",
						marginTop: 24,
						backgroundColor: "transparent",
						color: ColorV2.text.neutralHard,
						border: "1px solid " + ColorV2.border.neutralHard,
					}}
				>
					Quiero mi Pack Solidario
				</Button>
			</Section>
		</CellContainer>
	);
};
export default PackCell;
export interface Props {
	title: string;
	image: string;
	amount: number;
	onClick?: () => void;
}
